import { LOGOUT, SET_FORMS_LIST, SET_FORM } from "../actions/types";

const INITIAL_STATE = {
    current: {
        formID: null,
        title: null,
        description: null
    },
    list: []
};

const formsReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case SET_FORMS_LIST:
            return {
                ...state,
                list: action.payload.map(form => {
                    return {
                        formID: form.formID,
                        title: form.title,
                        description: form.description,
                        downloadCount: form.downloadCount
                    };
                })
            };
        case SET_FORM:
            return {
                ...state,
                current: {
                    formID: action.payload.formID,
                    title: action.payload.title,
                    description: action.payload.description
                }
            };
        case LOGOUT:
            return INITIAL_STATE;
        default:
            return state;
    }
};

export default formsReducer;